import React, { useState } from 'react'
import { Card, Button, Steps, Form } from 'antd'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import { useNavigate } from "react-router-dom"

import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { toJS, runInAction, set } from 'mobx'
//导入样式
import '@/scss/common.scss'
//引入图片
import leftImage from '@/assets/images/logo_left.jpg'


const Register = () => {

    const { RegisterStore } = useStore()

    // 取消按钮
    const [form] = Form.useForm()

    //步骤条
    const { Step } = Steps
    //路由跳转
    const navigate = useNavigate()
    const steps = [
        {
            title: '选择身份',
            content: <StepOne />,
        },
        {
            title: '填写注册信息',
            content: <StepTwo />,
        },
        {
            title: '完成',
            content: <StepThree />,
        },
    ]

    const [current, setCurrent] = useState(0)
    let newObjiect = {}
    const onFinish = async (values) => {
        delete values.province
        delete values.city
        delete values.county
        delete values.township
        delete values.village
        values.AreaCode = JSON.stringify(RegisterStore.AreaCode1) + "," + JSON.stringify(RegisterStore.AreaCode2) + "," + JSON.stringify(RegisterStore.AreaCode3) + "," + JSON.stringify(RegisterStore.AreaCode4) + "," + JSON.stringify(RegisterStore.AreaCode5)
        values.productions = JSON.stringify(toJS(RegisterStore.newCheckedValues))
        delete values.quepassword
        if (values.nickname && values.AreaCode && values.identity && values.productions) {
            runInAction(() => {
                set(RegisterStore, { firstStep: values })
            })
            setCurrent(current + 1)
        } else {
            runInAction(() => {
                set(RegisterStore, { secondStep: values })
            })
            newObjiect = Object.assign(toJS(RegisterStore.firstStep), toJS(RegisterStore.secondStep))
            await RegisterStore.registration(newObjiect)
        }
        if (values) {
            setCurrent(current + 1)
        }
    }
    const onFormLayoutChange = (x, value) => {
        var re = /^1[3-9]\d{9}$/;
        var result = re.test(value.mobile);
        if (result) {
            runInAction(() => {
                set(RegisterStore, { disabled: false })
            })
        } else {
            runInAction(() => {
                set(RegisterStore, { disabled: true })
            })
        }
        if (Object.keys(x)[0] === "province") {
            form.setFieldsValue({ city: undefined, county: undefined, township: undefined, village: undefined });
        }
        if (Object.keys(x)[0] === "city") {
            form.setFieldsValue({ county: undefined, township: undefined, village: undefined });
        }
        if (Object.keys(x)[0] === "county") {
            form.setFieldsValue({ township: undefined, village: undefined });
        }
        if (Object.keys(x)[0] === "township") {
            form.setFieldsValue({ village: undefined });
        }
    };
    return (
        <>
            <div className='login'>
                <Card className='login-container'>
                    <div className='left-img'>
                        <img src={leftImage} alt='' />
                    </div>
                    <Form onFinish={onFinish} onValuesChange={onFormLayoutChange} form={form}>
                        <div className='right-input' style={{ position: 'inherit' }}>
                            <div className='register'>
                                <div className='register-top'>
                                    <h2>经营主体应用管理系统</h2>
                                    <h3>已有账号，现在就<a onClick={() => { navigate("/login") }} style={{ marginLeft: '15px' }}>登录</a></h3>
                                </div>
                                <Steps current={current}>
                                    {steps.map((item) => (
                                        <Step key={item.title} title={item.title} />
                                    ))}
                                </Steps>
                                <div className="steps-content">{steps[current].content}</div>
                                <div className="steps-action">
                                    {current === steps.length - 3 && (
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit" style={{ width: "73%" }} key={new Date()}>
                                                下一步
                                            </Button>
                                        </Form.Item>
                                    )}
                                    {current === steps.length - 2 && (
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit" style={{ width: "35%" }}>
                                                去注册
                                            </Button>
                                            <Button style={{ width: '35%', margin: '0 0 0 25px' }} onClick={() => { setCurrent(current - 1) }}>
                                                上一步
                                            </Button>
                                        </Form.Item>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Form>
                </Card>
            </div>
        </>
    )
}

export default observer(Register)